"use client"

import * as React from "react"
import { Calendar } from "@/components/ui/calendar"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import type { DateRange } from "react-day-picker"

interface DownloadDatepickerDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm?: (dateRange: DateRange | undefined) => void
  loading?: boolean
}

export function DownloadDatepickerDialog({
  open,
  onOpenChange,
  onConfirm,
  loading = false,
}: DownloadDatepickerDialogProps) {
  const [dateRange, setDateRange] = React.useState<DateRange | undefined>(undefined)

  // Reset to last 30 days every time dialog opens
  React.useEffect(() => {
    if (open) {
      const to = new Date()
      const from = new Date()
      from.setDate(from.getDate() - 30)
      setDateRange({ from, to })
    }
  }, [open])

  const handleConfirm = () => {
    onConfirm?.(dateRange)
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[680px] p-6 bg-white">
        <DialogHeader className="relative">
          <DialogTitle className="text-2xl font-semibold text-gray-900">
            ดาวน์โหลดเอกสาร
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4">
          {/* Calendar Section */}
          <div className="flex justify-center gap-4">
            <Calendar
              mode="range"
              defaultMonth={(() => { const d = new Date(); d.setMonth(d.getMonth() - 1); return d })()}
              selected={dateRange}
              onSelect={(range) => setDateRange(range)}
              numberOfMonths={2}
              className="shadow-sm"
              classNames={{
                range_start: "bg-blue-100 rounded-l-md",
                range_middle: "bg-blue-100 rounded-none",
                range_end: "bg-blue-100 rounded-r-md",
              }}
            />
          </div>

          <div className="flex justify-end items-end gap-4">
            {/* Info Text */}
            <div className="mt-6 mb-4 grow">
              <p className="text-sm text-brand-primary">
                รายงานจะเริ่มนับตั้งแต่เวลา 00:00:00 - 23:59:59 ของแต่ละวัน
              </p>
            </div>

            {/* Action Button */}
            <div className="flex justify-end">
              <Button
                onClick={handleConfirm}
                variant="outline"
                disabled={!dateRange?.from || loading}
              >
                {loading ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดเอกสาร'}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
